







import {
	computed,
	defineComponent,
	onMounted,
	watch,
} from '@vue/composition-api';
import { v4 } from 'uuid';
import { getYoutube } from '@front-app/vendor/youtube';
import { getIdFromUrlOrId } from './util';

export default defineComponent({
	props: {
		// This can be either a video ID, or a video URL
		videoId: {
			type: String,
			required: true,
		},
		autoplay: Boolean,
	},
	setup(props, ctx) {
		const id = `youtube-player-${v4()}`;
		let player: YT.Player | undefined;

		const parsedVideoId = computed(() => getIdFromUrlOrId(props.videoId));

		watch((): [string | null, YT.Player | undefined] => [parsedVideoId.value, player], ([currId, currPlayer]) => {
			if (!currPlayer || !currId) {
				return;
			}
			currPlayer.loadVideoById(currId);
		}, { immediate: true });

		const initPlayer = async (videoId: string | null) => {
			await getYoutube();
			if (!videoId) {
				return;
			}
			player = new YT.Player(id, {
				width: '100%',
				height: '100%',
				videoId,
				playerVars: {
					autoplay: props.autoplay ? 1 : 0,
					playsinline: 1,
					controls: 1,
					modestbranding: 1,
					rel: 0,
				},
				events: {
					onStateChange: onPlayerStateChange,
				},
			});
		};
		onMounted(() => initPlayer(parsedVideoId.value));
		function onPlayerStateChange(event: YT.OnStateChangeEvent) {
			if (event.data === YT.PlayerState.ENDED) {
				ctx.emit('done');
			}
		}

		return {
			id,
		};
	},
});
